// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".contactWrapper[data-v-41f66c2a]{display:flex;flex-wrap:wrap;row-gap:1.5rem}.contactWrapper.table[data-v-41f66c2a]{display:grid;grid-template:\"a\";justify-content:center}@media(min-width:600px){.contactWrapper.table[data-v-41f66c2a]{justify-content:unset;grid-template:\"a b\"}}.headline-container[data-v-41f66c2a]{margin-bottom:1.2rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
